import { ToastType } from ".././toast";

type ToastPayload = { type: ToastType; title: string; message: string };
let toastFn: ((toast: ToastPayload) => void) | null = null;

export const registerToast = (fn: (toast: ToastPayload) => void) => {
  toastFn = fn;
};

export const showToast = (toast: ToastPayload) => {
  toastFn?.(toast);
};
